import { fetchAsObservable } from 'fetcher!sofe'

export function checkMfaStatus(token) {
  return fetchAsObservable(`/mfa-token/${token}`, {
    method: 'post',
    passThrough401: true
  })
}
